import { DATE_FORMAT } from '@ui-framework/index';
import dayjs from 'dayjs';

function formatDateTime(appointmentDate, AfterHour, BeforeHour) {
  if (!appointmentDate) return '';
  const date = dayjs(appointmentDate).format(DATE_FORMAT.MEDIUM_DATE);
  const after = AfterHour ? dayjs(AfterHour, 'HH:mm').format('hh:mm A') : '';
  const before = BeforeHour ? dayjs(BeforeHour, 'HH:mm').format('hh:mm A') : '';
  if (after && before) {
    return `${date} between ${after} - ${before}`;
  }
  if (after) {
    return `${date} after ${after}`;
  }
  if (before) {
    return `${date} before ${before}`;
  }
  return date;
}

export default formatDateTime;
